import "core-js/stable";
import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { ModalProvider } from "react-modal-hook";

import { AppScaffold } from "./components/AppScaffold";
import { setupEntrypoint } from "./utils/entrypoint";

import "./styles/base.scss";
import { MainRoutes } from "./components/Guest/MainRoutes";
import { StagingBanner } from "./components/AdminApp/AccountsApp/StagingBanner";
import { createI18nInstance } from "./utils/i18n/i18n";
import { globalPrintStyles } from "./components/__styles__/globalStyles";
const { history } = setupEntrypoint();
void createI18nInstance();

globalPrintStyles();

ReactDOM.render(
  <Suspense fallback={<div>Loading...</div>}>
    <AppScaffold history={history} app="guest">
      <ModalProvider>
        <StagingBanner />
        <MainRoutes />
      </ModalProvider>
    </AppScaffold>
  </Suspense>,
  document.getElementById("app")
);
